import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';

let baseStyles = {
    felxOne: { flex: 1 },
    headerIconContainer: {
        backgroundColor: 'black',
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: Device.isWeb ? 10 : null,
        top: 0
    },
    mainContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black'
    },
    backIcon: {
        width: 29,
        height: 29,
        margin: 11,
        marginTop: Device.isWeb ? 11 : 31,
        color: Theme.primaryTextColor
    },
    contentContainer: {
        justifyContent: 'center',
        alignItems: 'center'
    },
    title: {
        ...fontStyles.title,
        color: Theme.primaryTextColor,
        fontSize: 25,
        padding: 20,
        textAlign: 'center'
    },
    subTitle: {
        ...fontStyles.subtitle,
        color: Theme.primaryActiveColor,
        marginBottom: 20,
        fontSize: 18,
        textAlign: 'center',
        fontFamily: Theme.regularFont
    },
    hr: {
        width: '100%',
        color: Theme.primaryTextColor
    },
    content: {
        ...fontStyles.subtitle,
        color: Theme.primaryTextColor,
        marginBottom: Device.isTabletOrWeb ? 25 : null,
        marginTop: 25,
        maxWidth: Device.isPhone ? 300 : 600,
        textAlign: 'center',
        height: '50px',
        paddingHorizontal: Device.isTabletOrWeb ? 100 : null
    },
    or: {
        color: Theme.primaryTextColor,
        fontSize: 21,
        paddingVertical: 10,
        top: 10,
        alignItems: 'center'
    },
    plainContent: {
        ...fontStyles.subtitle,
        color: Theme.primaryTextColor,
        marginTop: 25,
        fontSize: 18,
        maxWidth: 400,
        textAlign: 'center',
        paddingHorizontal: 20
    },
    helpImage: {
        width: Device.isTabletOrWeb ? 500 : 300,
        borderRadius: 10,
        margin: 10,
        justifyContent: 'center'
    },
    helpContentContainer: {
        flexDirection: Device.isTabletOrWeb ? 'row' : 'column',
        alignItems: Device.isPhone ? 'center' : null,
        justifyContent: 'center',
        marginBottom: Device.isPhone ? 80 : null
    },
    helpContentText: {
        flex: Device.isTabletOrWeb ? 1 : null,
        flexDirection: 'column',
        padding: 20,
        alignItems: Device.isPhone ? 'center' : null
    },
    helpContentAssets: {
        flex: Device.isTabletOrWeb ? 1 : null,
        flexDirection: Device.isTabletOrWeb ? 'row' : 'column',
        padding: 20,
        alignItems: Device.isPhone ? 'center' : null
    },
    buttonContainer: {
        paddingTop: 30,
        width: 300,
        marginBottom: 30
    },
    button: {
        borderRadius: 3,
        width: '100%',
        height: 50,
        zIndex: 1,
        marginBottom: 10
    },
    buttonSpacing: {
        paddingTop: 10,
        marginBottom: 10,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'black'
    },
    buttonText: {
        color: Theme.primaryTextColor,
        fontSize: Theme.fontSizes.button,
        zIndex: 2
    },
    head: {
        paddingHorizontal: 20
    },
    scrollContant: {
        flex: 1,
        backgroundColor: 'black',
        justifyContent: 'center'
    },
    blacBackground: {
        backgroundColor: 'black'
    }
};

export default StyleSheet.create(baseStyles);
